<template>
  <div class="mobile-gallery">
    <h2 class="gallery-title">Galeria de Fotos</h2>
    
    <!-- Sections with horizontal carousels -->
    <div v-for="section in gallerySections" :key="section.section" class="gallery-section">
      <h3 class="section-title">{{ section.section }}</h3>
      
      <v-sheet class="carousel-wrapper">
        <v-slide-group
          show-arrows
          center-active
          class="photo-carousel"
        >
          <v-slide-group-item
            v-for="(photo, index) in section.photos"
            :key="`${section.section}-${index}`"
            v-slot="{ selectedClass }"
          >
            <div 
              class="carousel-item"
              :class="selectedClass"
              @click="openPhotoViewer(photo)"
            >
              <v-img
                :src="photo.path"
                :alt="photo.title"
                :lazy-src="photo.path"
                aspect-ratio="1"
                cover
                class="carousel-image"
                width="280"
                height="280"
              >
                <template v-slot:placeholder>
                  <div class="d-flex align-center justify-center fill-height">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </div>
                </template>
              </v-img>
              <div class="image-caption">{{ photo.title }}</div>
            </div>
          </v-slide-group-item>
        </v-slide-group>
      </v-sheet>
    </div>

    <!-- Fullscreen Photo Viewer with Pinch Zoom -->
    <v-dialog
      v-model="showPhotoViewer"
      fullscreen
      transition="dialog-bottom-transition"
      :retain-focus="false"
    >
      <div class="photo-viewer">
        <v-toolbar dark color="black" class="viewer-toolbar">
          <v-toolbar-title class="text-truncate">{{ currentPhoto?.title }}</v-toolbar-title>
        </v-toolbar>

        <vue-easy-lightbox
          :visible="showPhotoViewer"
          :imgs="currentPhoto ? [currentPhoto.path] : []"
          :index="0"
          @hide="closePhotoViewer"
          scrollDisabled
          :pinchEnabled="true"
          :maxZoom="5"
          :minZoom="0.1"
          :zoomScale="0.3"
          :enableSwipe="true"
        >
        </vue-easy-lightbox>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox'

export default {
  name: 'MobileGalleryComponent',
  
  components: {
    VueEasyLightbox
  },

  props: {
    gallerySections: {
      type: Array,
      required: true,
      default: () => []
    }
  },

  data() {
    return {
      showPhotoViewer: false,
      currentPhoto: null
    }
  },

  methods: {
    openPhotoViewer(photo) {
      this.currentPhoto = photo
      this.showPhotoViewer = true
    },

    closePhotoViewer() {
      this.showPhotoViewer = false
      this.currentPhoto = null
    }
  }
}
</script>

<style scoped>
.mobile-gallery {
  width: 100%;
  margin: 2rem auto;
  padding: 0;
  max-width: 1400px;
}

.gallery-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 2rem;
  color: var(--v-primary-base);
  padding: 0 1rem;
  text-align: left;
  letter-spacing: -0.5px;
  line-height: 1.2;
}

.section-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 2rem 0 1.5rem;
  color: var(--v-secondary-base);
  padding: 0 1rem;
  letter-spacing: -0.25px;
  line-height: 1.3;
}

.carousel-wrapper {
  margin-bottom: 2rem;
  background: transparent;
}

.photo-carousel {
  height: 320px;
}

.carousel-item {
  margin: 0 0.5rem;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.carousel-item:hover {
  transform: scale(1.02);
}

.carousel-image {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.image-caption {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0.75rem;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
  color: white;
  font-size: 0.9rem;
  font-weight: 500;
  line-height: 1.4;
}

.photo-viewer {
  background: black;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.viewer-toolbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
}

/* Media Queries */
@media (max-width: 600px) {
  .mobile-gallery {
    margin: 1.5rem auto;
  }

  .gallery-title {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .section-title {
    font-size: 1.25rem;
    margin: 1.5rem 0 1rem;
  }

  .photo-carousel {
    height: 260px;
  }

  .carousel-item {
    margin: 0 0.25rem;
  }
}
</style>
